module.exports = __webpack_public_path__ + "hyperion-v2-static/img/grid_highlight_green.c9301a1e.png";